import { Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { EnumCommentStatus } from "src/api/client/comment-v2.api.types";
import { CreationDate } from "src/components/common/creation-date/creation-date";
import { TComment } from "../comment.types";

type TMessageStatusIndicator = {
    comment: TComment;
};

const COMMENT_MESSAGE_STATUS_INDICATOR_TEST_ID = "comment-message-status-indicator";

export const MessageStatusIndicator = ({ comment }: TMessageStatusIndicator) => {
    const { t } = useTranslation("comment");

    return (
        <Flex data-test-id={COMMENT_MESSAGE_STATUS_INDICATOR_TEST_ID}>
            <CreationDate date={comment.lastUpdate} />
            {comment.status === EnumCommentStatus.Updated ? (
                <Text ml="0.5" fontSize="xs" color="gray.500">
                    {t("title.edited")}
                </Text>
            ) : null}
        </Flex>
    );
};
